import { type ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { ToastProvider } from './ToastProvider';
import { LoadingProvider } from './LoadingProvider';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider } from '@/contexts';

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <QueryProvider>
      <ToastProvider>
        <LoadingProvider>
          <ThemeProvider>
            <AuthProvider>{children}</AuthProvider>
          </ThemeProvider>
        </LoadingProvider>
      </ToastProvider>
    </QueryProvider>
  );
}
